"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var _ui = require("@probeton/ui");

var _solarReact = require("@solar/solar-react");

var _ACLHeader = _interopRequireDefault(require("../ACLHeader"));

var _ACLHeaderToggleButton = _interopRequireDefault(require("../ACLHeaderToggleButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    uploadDocButton: {
      margin: 12
    },
    uploadSpinner: {
      margin: 12
    },
    fileListItemWrapper: {
      width: '88%'
    },
    aclItemWrapper: {
      width: 48,
      height: 48
    }
  };
});

var DocumentManagement = function DocumentManagement(_ref) {
  var acl = _ref.acl,
      images = _ref.images,
      documents = _ref.documents,
      _editAcl = _ref.editAcl,
      editDocumentAcl = _ref.editDocumentAcl,
      addDocument = _ref.addDocument,
      addImage = _ref.addImage,
      editImageAcl = _ref.editImageAcl,
      setImageOpen = _ref.setImageOpen,
      setPdfOpen = _ref.setPdfOpen,
      getAWSSignedUrl = _ref.getAWSSignedUrl,
      labels = _ref.labels;
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(ImagesSection, {
    acl: acl.images,
    images: images,
    editAcl: function editAcl(imagesAcl) {
      return _editAcl(_objectSpread(_objectSpread({}, acl), {}, {
        images: imagesAcl
      }));
    },
    editImageAcl: editImageAcl,
    addImage: addImage,
    setImageOpen: setImageOpen,
    getAWSSignedUrl: getAWSSignedUrl,
    labels: labels
  }), /*#__PURE__*/_react["default"].createElement(DocumentsSection, {
    acl: acl.documents,
    documents: documents,
    editAcl: function editAcl(docsAcl) {
      return _editAcl(_objectSpread(_objectSpread({}, acl), {}, {
        documents: docsAcl
      }));
    },
    editDocumentAcl: editDocumentAcl,
    addDocument: addDocument,
    setPdfOpen: setPdfOpen,
    getAWSSignedUrl: getAWSSignedUrl,
    labels: labels
  }));
};

var ImagesSection = function ImagesSection(_ref2) {
  var acl = _ref2.acl,
      images = _ref2.images,
      editAcl = _ref2.editAcl,
      editImageAcl = _ref2.editImageAcl,
      addImage = _ref2.addImage,
      setImageOpen = _ref2.setImageOpen,
      getAWSSignedUrl = _ref2.getAWSSignedUrl,
      labels = _ref2.labels;

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      progress = _useState2[0],
      setProgress = _useState2[1];

  var fileUploadRef = (0, _react.useRef)();
  var classes = useStyles(); // <ACLHeader header="Afbeeldingen" acl={acl} onAclChange={(imagesAcl) => editAcl(imagesAcl)} />

  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_solarReact.Header, null, labels.images), /*#__PURE__*/_react["default"].createElement(_core.List, null, (images || []).map(function (image) {
    return /*#__PURE__*/_react["default"].createElement(_solarReact.Flex, {
      flexDirection: "row",
      alignItems: "center"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.fileListItemWrapper
    }, /*#__PURE__*/_react["default"].createElement(_solarReact.FileListItem, {
      label: image.caption,
      fileUrl: image.src,
      isImage: true,
      interactive: true,
      onClickOpen: function onClickOpen() {
        return setImageOpen(image.src);
      },
      onClickDownloadFile: function onClickDownloadFile() {
        return window.open(image.src, '__blank');
      }
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.aclItemWrapper
    }, /*#__PURE__*/_react["default"].createElement(_ACLHeaderToggleButton["default"], {
      acl: image.acl,
      onAclChange: function onAclChange(updatedImageAcl) {
        return editImageAcl(image._id, updatedImageAcl);
      },
      labels: labels.acl
    })));
  })), /*#__PURE__*/_react["default"].createElement(_solarReact.AlignRight, null, progress === 0 ? /*#__PURE__*/_react["default"].createElement(_core.Button, {
    variant: "outlined",
    color: "primary",
    className: classes.uploadDocButton,
    onClick: function onClick() {
      return fileUploadRef.current.startUpload();
    }
  }, labels.addImage) : /*#__PURE__*/_react["default"].createElement(_core.CircularProgress, {
    value: progress,
    className: classes.uploadSpinner
  })), /*#__PURE__*/_react["default"].createElement(_ui.FileUpload, {
    ref: fileUploadRef,
    getAWSSignedUrl: getAWSSignedUrl('covers') // TODO: Change S3 bucket name
    ,
    onComplete: function onComplete(_ref3) {
      var fileName = _ref3.name,
          src = _ref3.url,
          type = _ref3.type,
          size = _ref3.size;
      setProgress(0);
      addImage({
        original: src,
        caption: fileName,
        type: type,
        size: size,
        width: 500,
        height: 500
      });
    },
    onChange: function onChange(_ref4) {
      var nextProgress = _ref4.progress;
      return setProgress(nextProgress);
    }
  }));
};

var DocumentsSection = function DocumentsSection(_ref5) {
  var acl = _ref5.acl,
      documents = _ref5.documents,
      editAcl = _ref5.editAcl,
      editDocumentAcl = _ref5.editDocumentAcl,
      addDocument = _ref5.addDocument,
      setPdfOpen = _ref5.setPdfOpen,
      getAWSSignedUrl = _ref5.getAWSSignedUrl,
      labels = _ref5.labels;

  var _useState3 = (0, _react.useState)(0),
      _useState4 = _slicedToArray(_useState3, 2),
      progress = _useState4[0],
      setProgress = _useState4[1];

  var fileUploadRef = (0, _react.useRef)();
  var classes = useStyles(); // <ACLHeader
  //       header="Documenten"
  //       acl={acl}
  //       onAclChange={(documentsAcl) => editAcl(documentsAcl)}
  //     />

  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_solarReact.Header, null, labels.docs), /*#__PURE__*/_react["default"].createElement(_core.List, null, (documents || []).map(function (document) {
    return /*#__PURE__*/_react["default"].createElement(_solarReact.Flex, {
      flexDirection: "row",
      alignItems: "center"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.fileListItemWrapper
    }, /*#__PURE__*/_react["default"].createElement(_solarReact.FileListItem, {
      label: document.fileName,
      fileUrl: document.src,
      fileType: document.type,
      isImage: false,
      interactive: true,
      onClickOpen: function onClickOpen() {
        return setPdfOpen(document.src);
      },
      onClickDownloadFile: function onClickDownloadFile() {
        return window.open(document.src, '__blank');
      }
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.aclItemWrapper
    }, /*#__PURE__*/_react["default"].createElement(_ACLHeaderToggleButton["default"], {
      acl: document.acl,
      onAclChange: function onAclChange(updatedDocAcl) {
        return editDocumentAcl(document._id, updatedDocAcl);
      },
      labels: labels.acl
    })));
  })), /*#__PURE__*/_react["default"].createElement(_solarReact.AlignRight, null, progress === 0 ? /*#__PURE__*/_react["default"].createElement(_core.Button, {
    variant: "outlined",
    color: "primary",
    className: classes.uploadDocButton,
    onClick: function onClick() {
      return fileUploadRef.current.startUpload();
    }
  }, labels.addDoc) : /*#__PURE__*/_react["default"].createElement(_core.CircularProgress, {
    value: progress,
    className: classes.uploadSpinner
  })), /*#__PURE__*/_react["default"].createElement(_ui.FileUpload, {
    ref: fileUploadRef,
    getAWSSignedUrl: getAWSSignedUrl('covers') // TODO: Change S3 bucket name
    ,
    onComplete: function onComplete(_ref6) {
      var fileName = _ref6.name,
          src = _ref6.url,
          type = _ref6.type,
          size = _ref6.size;
      setProgress(0);
      addDocument({
        fileName: fileName,
        caption: fileName,
        src: src,
        type: type,
        size: size
      });
    },
    onChange: function onChange(_ref7) {
      var nextProgress = _ref7.progress;
      return setProgress(nextProgress);
    }
  }));
};

var _default = DocumentManagement;
exports["default"] = _default;